import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class OrderDraftService {
  orderHeader: any = null;
  orderLines: any[] = [];

  setDraft(orderHeader: any, orderLines: any[]) {
    this.orderHeader = orderHeader;
    this.orderLines = orderLines;
  }

  clearDraft() {
    this.orderHeader = null;
    this.orderLines = [];
  }
}